import Vue from "vue";
import Vuex from "vuex";

import { alert } from "./modules/alert";
import { users } from "./modules/user";
import { companies } from "./modules/company";
import { devices } from "./modules/device";
import { deviceFields } from "./modules/deviceFields";
import { deviceDatas } from "./modules/deviceData";
import { logs } from "./modules/log";
import { languages } from "./modules/language";
import { connectors } from "./modules/connector";

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    users,
    companies,
    devices,
    deviceFields,
    deviceDatas,
    logs,
    alert,
    connectors,
    languages
  },
  plugins: [createPersistedState()]
});
